import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';
import {paginationQuerySchema, paginatedResponseSchema} from '../utils/pagination';

const c = initContract();

export const knowledgeBasesContract = c.router(
  {
    create: {
      method: 'POST',
      path: '/',
      responses: {
        201: DB_SCHEMAS.selectKnowledgeBase,
        403: z.object({message: z.string()})
      },
      body: DB_SCHEMAS.createKnowledgeBase.pick({
        name: true,
        description: true,
        embeddingModelId: true,
        avatar: true,
        tenantId: true
      }),
      summary: 'Create a knowledge base'
    },
    get: {
      method: 'GET',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: DB_SCHEMAS.selectKnowledgeBase,
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      }
    },
    update: {
      method: 'PUT',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      body: DB_SCHEMAS.updateKnowledgeBase,
      responses: {
        200: z.array(DB_SCHEMAS.selectKnowledgeBase),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      }
    },
    list: {
      method: 'GET',
      path: `/`,
      query: z
        .object({
          tenantId: z.string().optional()
        })
        .merge(paginationQuerySchema)
        .extend({
          sortBy: z.enum(['name', 'createdAt', 'updatedAt', 'sourceCount']).optional()
        }),
      responses: {
        200: paginatedResponseSchema(DB_SCHEMAS.selectKnowledgeBase),
        403: z.object({message: z.string()}),
        500: z.object({
          data: z.array(z.never()),
          pagination: z.object({page: z.number(), pageSize: z.number(), total: z.number(), totalPages: z.number()})
        })
      },
      summary: 'Get all knowledge bases'
    },
    delete: {
      method: 'DELETE',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: z.array(DB_SCHEMAS.selectKnowledgeBase),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      body: null
    }
  },
  {
    pathPrefix: '/knowledge-bases'
  }
);
